import type { VisitReportList } from '/@/hooks/visit-reports';

export const hasVisitReportForField = (visitReports: VisitReportList[], fieldId: number): boolean =>
    visitReports.some((report) => report.fieldObservations?.some((observation) => observation.field === fieldId));
